import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { UtilsService } from '../../services/utils.service';
import { SocialAuthService } from "@abacritt/angularx-social-login";
import { Subscription } from 'rxjs/internal/Subscription';
import { environment } from '../../../environments/environment';
import { SignInService } from '../../services/sign-in.service';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-profile-sidebar',
  standalone:true,
  imports : [CommonModule,RouterModule],
  templateUrl: './profile-sidebar.component.html',
  styleUrls: ['./profile-sidebar.component.scss']
})
export class ProfileSidebarComponent implements OnInit ,OnDestroy{
  @Input('notShowActiveClass') notShowActiveClass!: boolean;
  @Input('hideLogoutButton') hideLogoutButton!: boolean;
  @Output() routeSet = new EventEmitter<string>();
  environment: any = environment;
  isLogIn = false;
  sub:Subscription=new Subscription()
  profileSideBarData:any[]=[]
  constructor(public utils: UtilsService, public router: Router, private SignInService: SignInService, private authService: SocialAuthService) {
  }

  ngOnInit(): void {
    this.isLogIn = this.SignInService.getIsAuth();
    this.sub.add(this.SignInService.getAuthStatusListener()
      .subscribe((response: any) => {
        this.isLogIn = response
      }))
      this.profileSideBarData=this.utils.profileSideBarData
  }
  routeHandler() {
    this.routeSet.emit();
  }

  onSignOut() {
    this.utils.showLoading();
    this.SignInService.logOut();
    this.routeSet.emit('signOut');
  }

  socialSignOut(): void {
    this.sub.add(  this.authService.authState.subscribe((user) => {
      if (user) {
        this.authService.signOut();
      }
    }));
  }
  ngOnDestroy(): void {
  
    this.sub.unsubscribe()
  }
}
